export default __webpack_public_path__ + "static/media/practo4.e380666f.png";